/**
 * Created by chenzhenxing
 */
// 依赖
import Vue from 'vue';
import VueResource from 'vue-resource';
import VueLazyload from 'vue-lazyload';
import KNB from '@dp/knb';
Vue.use(VueLazyload);
Vue.use(VueResource);
//登入
window.Login = require('@lib/login');
//环境判断
window.Env = require('@lib/env');
// less
import "../less/base/reset.less";
import "../less/qing_ren/animation.less";

// 主容器
import MainContainer from '../act/march_promotion/containers/index_page.vue';
// 渲染
new Vue({
    el: '#main',
    render: h=>h(MainContainer)
})



// WEBPACK FOOTER //
// ./src/js/mach_promotion_index.js